import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=72074b96&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=72074b96&prod&scoped=true&lang=css"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=72074b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72074b96",
  null
  
)

export default component.exports